import { adminOrganisationsService } from '@/services/admin-organisations.service';
import type { AdminFilters } from '@/types/admin.types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export function useAdminOrganisations(filters: AdminFilters = {}) {
  return useQuery({
    queryKey: ['admin-organisations', filters],
    queryFn: () => adminOrganisationsService.getAll(filters),
  });
}

export function useAdminOrganisationDetail(uuid: string | undefined) {
  return useQuery({
    queryKey: ['admin-organisation', uuid],
    queryFn: () => adminOrganisationsService.getById(uuid!),
    enabled: !!uuid,
  });
}

export function useSuspendOrganisation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid: string) => adminOrganisationsService.suspend(uuid),
    onSuccess: () => { toast.success('Organisation suspendue'); qc.invalidateQueries({ queryKey: ['admin-organisations'] }); },
    onError: () => toast.error('Erreur lors de la suspension'),
  });
}

export function useActivateOrganisation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid: string) => adminOrganisationsService.activate(uuid),
    onSuccess: () => { toast.success('Organisation activée'); qc.invalidateQueries({ queryKey: ['admin-organisations'] }); },
    onError: () => toast.error("Erreur lors de l'activation"),
  });
}

export function useDeleteOrganisation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (uuid: string) => adminOrganisationsService.deleteOrganisation(uuid),
    onSuccess: () => { toast.success('Organisation supprimée'); qc.invalidateQueries({ queryKey: ['admin-organisations'] }); },
    onError: () => toast.error('Erreur lors de la suppression'),
  });
}
